import { PublicConfig } from '../../models/environment.public';
import { commonEnvVars, devEnv } from 'src/common/environments/environment.public.common';

const config: PublicConfig = {
    appId: 'l7xxe370944285d04b07a8fd77ce2945bda2',
    appziSrc: `https://w.appzi.io/w.js?token=I3Dkk`,
    brand: 'Comfortmaker',
    brandPath: 'icp',
    publicBaseUrl: 'https://dev-comfortmaker.hvacpartners.com',
    siteCode: 790,
    ...devEnv
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const environment: any = { ...commonEnvVars(config) };
